var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLobbyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23312 6.75195C6.01418 6.75195 6.79525 6.90864 7.4982 7.22202V16.7017C6.79525 17.0934 6.01418 17.2501 5.23312 17.2501C2.34319 17.2501 0 14.8997 0 12.001C0 9.10228 2.34319 6.75195 5.23312 6.75195Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21553 8.71063V15.9966C9.34043 15.9653 9.44812 15.9315 9.55424 15.8983C9.71358 15.8483 9.8694 15.7994 10.0747 15.7616C10.5557 15.673 10.8369 15.645 11.3244 15.6833C11.8554 15.7249 12.6522 15.9966 12.6522 15.9966L12.9646 16.1533C12.9646 16.1533 13.0212 16.175 13.0427 16.1533C13.0643 16.1317 13.0427 16.075 13.0427 16.075C13.0427 16.075 12.9646 15.84 12.8865 15.7616L9.21553 8.71063Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3144 7.29614C17.0275 6.98514 17.8198 6.75189 18.6914 6.75189C21.623 6.67414 24 9.00663 24 12.0389C24 14.9156 21.623 17.2481 18.6914 17.2481C17.8198 17.2481 17.0275 17.0149 16.3144 16.7039V7.29614Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 13.2053C13.4619 13.2053 14.4919 14.9935 14.5712 15.149C14.6504 8.07376 14.5712 7.80002 14.5712 7.80002L14.0192 8.06249C14.0192 8.06249 13.8581 8.15153 13.5411 8.22928C13.2242 8.30703 12.828 8.30703 12.4319 8.22928C12.0357 8.15153 11.6395 8.07378 11.2434 7.91828L10.8472 7.76278C10.732 7.7177 10.6893 7.69692 10.6824 7.70515C10.678 7.71042 10.6882 7.72763 10.7035 7.75801C10.7035 7.75801 10.8472 8.07378 10.9264 8.22928C11.7188 9.86203 12.5903 11.5725 13.4619 13.2053Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobbyLogo);
export default __webpack_public_path__ + "static/media/lobby-logo.d2b9b6af.svg";
export { ForwardRef as ReactComponent };